import List from "components/list";
import ProjectLayout from "@/modules/work/projects/layout";
import React from "react";
import { useParams } from "react-router-dom";
import { StatusCell } from "@/components/status/cell";
import { DateCell } from "@/components/date/cell";
import MilestoneFilters from "@/modules/work/projects/milestones/filters";
import { EmployeeCell } from "components/cell/employee/cell";
import { useProject } from "../context";
import { ROUTE } from "@/lib/utils";
import { getEmployeeFields } from "components/user/config";

export default function ProjectMilestones() {
  const { project_slug } = useParams();
  const { id } = useProject()

  if (!id) return null;
  const fields = [
    "id",
    "name",
    "status",
    getEmployeeFields("coordinator"),
    "start_date",
    "end_date",
  ];
  const columns = [
    {
      id: "name",
      header: "Name",
      accessorKey: "name",
    },
    {
      id: "coordinator",
      header: "MC",
      accessorKey: "coordinator",
      cell: EmployeeCell,
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      id: "start_date",
      header: "Start Date",
      accessorKey: "start_date",
      sortable: true,
      cell: DateCell,
    },
    {
      id: "end_date",
      header: "End Date",
      accessorKey: "end_date",
      sortable: true,
      cell: DateCell,
    },
  ];

  const defaultFilters = {
    job: { project: { _eq: id } },
  };

  return (

    <List
      title="Milestones"
      storageKey={project_slug}
      endPoint="milestones"
      filters={defaultFilters}
      columns={columns}
      meta={{ fields }}
      renderFilters={MilestoneFilters}
      href={(item) => ROUTE.MILESTONE(item.id)}
    />

  );
}
